import styled from "styled-components"

export const CardsContainer = styled.div`
  margin: 0 auto;
  padding: 20px 0;
  h2 {
    font-size: 36px;
    color: #fff;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      font-size: ${({ theme }) => theme.fontSizes.md};
    }
  }
`

export const PostCard = styled.div`
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  max-width: ${({ size }) => (size === "small" ? `400px` : `100%`)};
  max-height: ${({ size }) => (size === "small" ? `400px` : `100%`)};

  h3 {
    color: #777d71;
    margin: 0;
  }

  .gatsby-image-wrapper {
    object-fit: cover;
    width: 100%;
    margin: 0;
    height: ${({ size }) => (size === "small" ? `100px` : `150px`)};
  }

  p.date {
    color: ${({ theme }) => theme.colors.lightGreen};
    font-weight: 900;
    font-size: 12px;
    margin: 0;
  }

  p.post_text {
    padding-top: 20px;
    max-width: 530px;
    font-size: .7rem;
    line-height: 1rem;
    letter-spacing: 0.05em;
    color: #000;
    word-wrap: break-word;
  }

  div.star_count {
    padding-top: 20px;
    color: ${({ theme }) => theme.colors.yellow};
    justify-content: flex-end;
    align-items: center;
    display: flex;

    svg {
      fill: ${({ theme }) => theme.colors.yellow};
    }

    p {
      margin: 0;
      font-size: ${({ theme }) => theme.fontSizes.xs};
    }
  }

  a.post_btn {
    display: inline-block;
    justify-self: center;
    margin-top: 20px;
    color: ${({ theme }) => theme.colors.darkGreen};
    font-size: ${({ theme }) => theme.fontSizes.xs};
    border-radius: 2px;

    :hover {
      color: ${({ theme }) => theme.colors.lightGreen};
    }
  }
`
